<script setup lang="ts">
defineProps<{
  title: string
  eyebrow: string
  sectionLink: string
  imageLink: string
}>()

const localePath = useLocalePath()
</script>

<template>
  <nuxt-link :to="localePath(sectionLink)">
    <div class="group flex w-80 cursor-pointer flex-col items-center sm:w-96">
      <img class="mb-10 w-full grayscale transition-all group-hover:filter-none" :src="imageLink" :alt="eyebrow" />
      <span class="mb-2 text-base font-medium uppercase text-[#6B7280]">
        {{ eyebrow }}
      </span>
      <h2 class="text-center text-3xl">
        {{ title }}
      </h2>
      <span class="mt-4 flex items-center py-3 font-bold text-primary-darkish">
        {{ $t('common.see_how_it_works') }}
        <i class="gg-arrow-long-right ml-4"></i>
      </span>
    </div>
  </nuxt-link>
</template>
